import { autoserialize } from 'cerialize';

export class PaginatedResponse {
  @autoserialize
  totalElements: number;

  @autoserialize
  totalPages: number;

  @autoserialize
  pageSize: number;

  @autoserialize
  pageNumber: number;
}
